import React, { useEffect } from "react";
import useSEO from "../../hooks/useSEO";
import seoConfig from "../../hooks/seoConfig";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function PapillomaRemoval() {
  useSEO(seoConfig.papillomaRemoval);

  useEffect(() => {
    const items = document.querySelectorAll(".faq-item");

    items.forEach((item) => {
      const btn = item.querySelector(".faq-question");

      btn.addEventListener("click", () => {
        item.classList.toggle("active");
      });
    });
  }, []);

  return (
    <main className="page">
      <div className="container">
        <Breadcrumbs />

        {/* HERO */}
        <section className="hero">
          <h1 className="hero__title">Удаление папиллом</h1>
          <p className="hero__text">
            Безопасное и эффективное удаление новообразований кожи современными
            методами с минимальным риском и быстрым восстановлением.
          </p>
          <button className="btn btn--primary">Записаться на приём</button>
        </section>

        {/* КОГДА УДАЛЯТЬ */}
        <section className="section">
          <h2 className="section__title">Когда необходимо удаление</h2>

          <ul className="list list--grid">
            <li>Увеличение размеров</li>
            <li>Изменение формы или цвета</li>
            <li>Боль, зуд, воспаление</li>
            <li>Частая травматизация</li>
            <li>Расположение на лице или шее</li>
          </ul>
        </section>

        {/* МЕТОДЫ */}
        <section className="section">
          <h2 className="section__title">Методы удаления</h2>

          <div className="section__cards">
            <div className="section__card">
              *<h3 className="section__subtitle">Лазерное удаление</h3>
              <ul>
                <li>Безболезненно</li>
                <li>Высокая точность</li>
                <li>Без рубцов</li>
              </ul>
            </div>

            <div className="section__card">
              *<h3 className="section__subtitle">Радиоволновой метод</h3>
              <ul>
                <li>Быстрое заживление</li>
                <li>Минимальное повреждение</li>
                <li>Подходит для лица</li>
              </ul>
            </div>

            <div className="section__card">
              *<h3 className="section__subtitle">Криодеструкция</h3>
              <ul>
                <li>Доступно</li>
                <li>Для небольших папиллом</li>
              </ul>
            </div>
          </div>
        </section>

        {/* КАК ПРОХОДИТ */}
        <section className="section">
          <h2 className="section__title">Как проходит процедура</h2>

          <ol className="steps">
            <li>Осмотр врача</li>
            <li>Диагностика</li>
            <li>Выбор метода</li>
            <li>Удаление</li>
            <li>Рекомендации</li>
          </ol>
        </section>

        {/* ПРЕИМУЩЕСТВА */}
        <section className="section section--accent">
          <h2 className="section__title">Преимущества</h2>

          <div className="advantages">
            <div>Опытные врачи</div>
            <div>Современное оборудование</div>
            <div>Стерильность</div>
            <div>Индивидуальный подход</div>
          </div>
        </section>

        {/* CTA */}
        <section className="cta">
          <h2 className="section__title">Запишитесь на консультацию</h2>
          <button className="btn btn--primary">Записаться</button>
        </section>

        {/* ВРАЧ */}
        <section className="section doctor">
          <div className="doctor__card">
            <img
              src="/images/staff/Image-m.png"
              alt="Врач"
              className="doctor__img"
            />
            <div>
              <h3 className="doctor__name">Иванов Иван Иванович</h3>
              <p className="doctor__desc">
                Врач-дерматолог, 12 лет опыта. Специализируется на удалении
                новообразований кожи современными методами.
              </p>
              <div className="doctor__badges">
                <span>12+ лет опыта</span>
                <span>5000+ процедур</span>
                <span>Без рубцов</span>
              </div>
            </div>
          </div>
        </section>

        {/* ОТЗЫВЫ */}
        <section className="section">
          <h2 className="section__title">Отзывы пациентов</h2>

          <div className="reviews">
            <div className="review">
              <p>
                Очень аккуратно удалили папиллому, всё быстро зажило.
                Рекомендую!
              </p>
              <span>— Анна</span>
            </div>

            <div className="review">
              <p>Боялся процедуры, но всё прошло без боли. Отличный врач.</p>
              <span>— Дмитрий</span>
            </div>

            <div className="review">
              <p>Делала лазером — никаких следов. Спасибо!</p>
              <span>— Ольга</span>
            </div>
          </div>
        </section>

        {/* ЦЕНЫ */}
        <section className="section">
          <h2 className="section__title">Цены</h2>

          <div className="prices">
            <div className="price-card">
              *<h3 className="section__subtitle">Лазерное удаление</h3>
              <p className="price">от 1500 ₽</p>
            </div>

            <div className="price-card">
              *<h3 className="section__subtitle">Радиоволновое</h3>
              <p className="price">от 1300 ₽</p>
            </div>

            <div className="price-card">
              *<h3 className="section__subtitle">Криодеструкция</h3>
              <p className="price">от 800 ₽</p>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="section">
          <h2 className="section__title">Вопросы и ответы</h2>

          <div className="faq">
            <div className="faq-item">
              <button className="faq-question">Больно ли удалять?</button>
              <div className="faq-answer">
                Процедура проходит с минимальным дискомфортом.
              </div>
            </div>

            <div className="faq-item">
              <button className="faq-question">Остаются ли рубцы?</button>
              <div className="faq-answer">В большинстве случаев — нет.</div>
            </div>

            <div className="faq-item">
              <button className="faq-question">
                Сколько длится процедура?
              </button>
              <div className="faq-answer">Обычно 10–30 минут.</div>
            </div>
          </div>
        </section>

        {/* STICKY КНОПКА */}
        <button className="sticky-btn">Записаться</button>
      </div>
    </main>
  );
}
